const defaultAnnouncements = {
  onDragStart(id) {
  },
  onDragOver(id, overId) {
    if (overId) {
      return;
    }
  },
  onDragEnd(id, overId) {
    if (overId) {
      return;
    }
  },
  onDragCancel(id) {
  },
};

export default defaultAnnouncements;
